import { LANGUAGES } from '@/data'

// prettier-ignore
const I18N_ENGLISH = {
  // Blog
  postedBy: 'Posted by #{author}',
  readingTime: '#{readingTimeMinutes} min read',
  caseStudy: 'Case Study',
  readArticle: 'Read Article',
  numberOfArticles: '#{count} articles',
  resultsForTerm: 'Results for "#{term}"',
  resultsForCategory: 'Category: #{category}',
  resultsForReference: 'Referenced by #{reference}',
  category: 'Category',
  theme: 'Theme',

  // Case study
  location: 'Location',
  country: 'Country',
  transactionYear: 'Transaction Year',
  sector: 'Sector',
  fund: 'Fund',
  type: 'Type',
  size: 'Size',

  // Bio overlay
  bio: 'Bio',

  // Video
  playVideo: 'Play Video',
  pauseVideo: 'Pause Video',

  // Carousel
  clickOrSwipeForMore: 'Click or swipe for more',

}

const I18N_DK = {
  postedBy: 'Skrevet af #{author}',
  readingTime: '#{readingTimeMinutes} min læsetid',
  caseStudy: 'Case',
  readArticle: 'Læs artiklen',
  numberOfArticles: '#{count} Artikler',
  resultsForTerm: 'Resultater for "#{term}"',
  resultsForCategory: 'Kategori: #{category}',
  resultsForReference: 'Omtalt i #{reference}',
  location: 'Lokation',
  country: 'Land',
  transactionYear: 'Transaktionsår',
  sector: 'Sektor',
  fund: 'Fond',
  type: 'Type',
  size: 'Størrelse',
  playVideo: 'Afspil video',
  pauseVideo: 'Sæt videon på pause',
  clickOrSwipeForMore: 'Klik eller swipe for at se mere',
}

const I18N_SE = {
  postedBy: 'Publicerad av #{author}',
  readingTime: '#{readingTimeMinutes} min lästid',
  caseStudy: 'Case',
  readArticle: 'Läs artikeln',
  numberOfArticles: '#{count} artiklar',
  resultsForTerm: 'Resultat för "#{term}"',
  resultsForCategory: 'Kategori: #{category}',
  resultsForReference: 'Omnämnd av #{reference}',
  location: 'Plats',
  country: 'Land',
  transactionYear: 'Transaktionsår',
  sector: 'Sektor or Bransch',
  fund: 'Fond',
  type: 'Typ',
  size: 'Storlek',
  playVideo: 'Spela upp video',
  pauseVideo: 'Pausa video',
  clickOrSwipeForMore: 'Klicka eller svep för mer',
}

const I18N_DE = {
  postedBy: 'Veröffentlicht von #{author}',
  readingTime: '#{readingTimeMinutes} min lesezeit',
  caseStudy: 'Fallstudie',
  readArticle: 'Artikel lesen',
  numberOfArticles: '#{count} Artikel',
  resultsForTerm: 'Ergebnisse für "#{term}"',
  resultsForCategory: 'Kategorie: #{category}',
  resultsForReference: 'Referenziert von #{reference}',
  location: 'Standort',
  country: 'Land',
  transactionYear: 'Transaktionsjahr',
  sector: 'Sektor',
  fund: 'Fonds',
  type: 'Typ',
  size: 'Größe',
  playVideo: 'Video abspielen',
  pauseVideo: 'Video pausieren',
  clickOrSwipeForMore: 'Klicken oder wischen für mehr',
}

const I18N_FI = {
  postedBy: 'Julkaissut #{author}',
  readingTime: '#{readingTimeMinutes} min lukuaika.',
  caseStudy: 'Case ',
  readArticle: 'Lue artikkeli',
  numberOfArticles: '#{count} artikkelia',
  resultsForTerm: 'Tulokset  "#{term}"',
  resultsForCategory: 'Kategoria: #{category}',
  resultsForReference: 'Mainittu  #{reference}',
  location: 'Sijainti',
  country: 'Maa',
  transactionYear: 'Sijoitusvuosi',
  sector: 'Sektori',
  fund: 'Rahasto',
  type: 'Tyyppi',
  size: 'Koko',
  playVideo: 'Toista video',
  pauseVideo: 'Pysäytä video',
  clickOrSwipeForMore: 'Klikkaa tai pyyhkäise nähdäksesi lisää',
}

const I18N_PL = {
  postedBy: 'Opublikowane przez #{author}',
  readingTime: '#{readingTimeMinutes} min czytania',
  caseStudy: 'Case Study',
  readArticle: 'Przeczytaj artykuł',
  numberOfArticles: '#{count} artykułów',
  resultsForTerm: 'Wyniki dla  "#{term}"',
  resultsForCategory: 'Kategoria: #{category}',
  resultsForReference: 'Wspomniane w #{reference}',
  location: 'Lokalizacja',
  country: 'Kraj',
  transactionYear: 'Data transakcji',
  sector: 'Sektor',
  fund: 'Fundusz',
  type: 'Typ',
  size: 'Powierzchnia',
  playVideo: 'Odtwórz video',
  pauseVideo: 'Wstrzymaj video',
  clickOrSwipeForMore: 'Kliknij lub przesuń, aby zobaczyć więcej',
}

const I18N_NO = {
  postedBy: 'Skrevet av #{author}',
  readingTime: '#{readingTimeMinutes} min lesetid',
  caseStudy: 'Case studie',
  readArticle: 'Lese en artikkel',
  numberOfArticles: '#{count} artikler',
  resultsForTerm: 'Resultat for "#{term}"',
  resultsForCategory: 'Kategori: #{category}',
  resultsForReference: 'Referanse #{reference}',
  location: 'Lokasjon',
  country: 'Land',
  transactionYear: 'Transaksjons år',
  sector: 'Sektor',
  fund: 'Fond',
  type: 'Type',
  size: 'Størrelse',
  playVideo: 'Spill film',
  pauseVideo: 'Pause film',
  clickOrSwipeForMore: 'Klikk eller swipe for mer',
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const getLangMerged = (langObject: any) => {
  return {
    ...I18N_ENGLISH,
    ...langObject,
  }
}

export const I18N_TEXT = {
  [LANGUAGES.EN]: I18N_ENGLISH,
  [LANGUAGES.DK]: getLangMerged(I18N_DK),
  [LANGUAGES.SE]: getLangMerged(I18N_SE),
  [LANGUAGES.DE]: getLangMerged(I18N_DE),
  [LANGUAGES.FI]: getLangMerged(I18N_FI),
  [LANGUAGES.PL]: getLangMerged(I18N_PL),
  [LANGUAGES.NO]: getLangMerged(I18N_NO),
}
